import moment from "moment"
import { isValid, parse } from "date-fns"
import { CommonConstant } from "shared/constants/common-constant"

function dateTimeFormat(date) {
  let result

  if (date) {
    const localDate = new Date(date)
    const options = { year: "numeric", month: "2-digit", day: "2-digit" }
    const fieldDate = localDate.toLocaleDateString("en-AU", options)
    // let optWithoutSecond = {hour: '2-digit', minute:'2-digit',hour12:true};
    const opt = { hour: "2-digit", minute: "2-digit", hour12: true }
    const time = localDate.toLocaleTimeString("en-AU")
    const resultTime = time === "12:00:00 am" ? "" : localDate.toLocaleTimeString("en-AU", opt).toString().toUpperCase()
    return `${fieldDate} ${resultTime}`
  }

  return result
}

function formatStandardDate(date) {
  if (date === null) return ""

  if (moment(date).format("HH:mm:ss.SSS") !== "00:00:00.000") {
    return moment(date).format("DD/MM/YYYY h:mm A")
  }
  return moment(date).format("DD/MM/YYYY")
}

function formatDisplayDate(date) {
  if (!date) return ""

  date = parseDate(date)

  if (date === null) return ""

  return moment(date).format("DD/MM/YYYY")
}

function formatDisplayDateTime(date) {
  if (!date) return ""

  date = parseDate(date)

  if (date === null) return ""

  return moment(date).format("DD/MM/YYYY h:mm A")
}

function parseDate(val) {
  if (!val) return null

  try {
    if (typeof val === "string") {
      if (val.includes("-") || val.includes("T")) return new Date(val)

      val = val.replaceAll(".", "/")

      let res = parse(val, CommonConstant.DATE_FORMAT, new Date())
      if (isValid(res) && res.getFullYear() > 2000) return res

      res = parse(val, "dd/MM/yy", new Date())
      if (isValid(res) && res.getFullYear() > 2000) return res

      res = parse(val, "MM/dd/yyyy", new Date())
      if (isValid(res) && res.getFullYear() > 2000) return res

      return parse(val, "MM/dd/yy", new Date())
    }
  } catch {
    return null
  }

  return new Date(val)
}

function formatSavingDate(date) {
  try {
    if (!date) return ""

    return moment(date).format("YYYY-MM-DD")
  } catch {
    return ""
  }
}

export { parseDate, dateTimeFormat, formatStandardDate, formatDisplayDate, formatDisplayDateTime, formatSavingDate }
